import { motion } from "framer-motion";

export default function ProgramTimeline({ program = [] }) {
  if (!program.length) return null;
  return (
    <section className="py-20 sm:py-28 px-6 sm:px-12 bg-white" data-testid="program-section">
      <div className="max-w-3xl mx-auto">
        <p className="eyebrow mb-4 text-center">Il programma</p>
        <h2 className="font-wed text-3xl sm:text-4xl mb-14 text-center">La giornata</h2>
        <div className="relative">
          <div className="absolute left-[52px] sm:left-[68px] top-2 bottom-2 w-px" style={{ background: "var(--wed-primary)", opacity: 0.35 }} />
          <div className="space-y-10">
            {program.map((item, i) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="flex gap-6 sm:gap-10 items-start"
                data-testid={`program-item-${i}`}
              >
                <div className="font-wed text-lg sm:text-xl w-[52px] sm:w-[68px] shrink-0 text-right" style={{ color: "var(--wed-primary)" }}>
                  {item.orario}
                </div>
                <div className="relative pl-6">
                  <span className="absolute left-[-5px] top-2 w-2.5 h-2.5 rounded-full" style={{ background: "var(--wed-primary)" }} />
                  <h3 className="font-wed text-xl sm:text-2xl mb-1">{item.titolo}</h3>
                  {item.descrizione && <p className="text-neutral-500 text-sm leading-relaxed">{item.descrizione}</p>}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
